import button_close from '../assets/images/button-close.png';
import button_info from '../assets/images/button-info.png';
import button_group from '../assets/images/button-group.png';
import button_fanpage from '../assets/images/button-fanpage.png';
import button_community from '../assets/images/button-community.png';

interface Props {
  isShow: boolean;
  setShow: (value: boolean) => void;
}

const CommunityModal = ({ isShow, setShow }: Props) => {
  const clazzShowModal = isShow ? 'modal-open' : '';

  return (
    <div id='community-modal' className={`${clazzShowModal}`}>
      <div className='modal-content'>
        <div id='close-modal-btn' onClick={() => setShow(false)}>
          <img src={button_close} alt='button_close' />
        </div>
        <div className='list-community p-8'>
          <div className='community-item'>
            <a
              href='https://zalo.me/talavuonglaogiazagoo'
              target='_blank'
              rel='noreferrer'
            >
              <img
                src={button_info}
                alt='Trang thông tin Ta Là Vương Lão Gia'
              />
            </a>
          </div>
          <div className='community-item'>
            <a
              href='https://zalo.me/g/jxjpsn142'
              target='_blank'
              rel='noreferrer'
            >
              <img
                src={button_group}
                alt='Nhóm trò chuyện Ta Là Vương Lão Gia'
              />
            </a>
          </div>
          <div className='separator'></div>
          <div className='community-item'>
            <a
              href='https://www.facebook.com/vuonglaogia.zagoo.vn/'
              target='_blank'
              rel='noreferrer'
            >
              <img src={button_fanpage} alt='Fanpage Ta Là Vương Lão Gia' />
            </a>
          </div>
          <div className='community-item'>
            <a
              href='https://www.facebook.com/groups/vuonglaogia.zagoo.vn'
              target='_blank'
              rel='noreferrer'
            >
              <img src={button_community} alt='Cộng đồng Ta Là Vương Lão Gia' />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommunityModal;
